import { createContext, useContext } from 'react';

export interface DataDashboardFilterState {
  time: Record<string, any>;
  regionOptions: Record<string, any>[];
  accountOptions: Record<string, any>[];
  sourceTypeOptions: Record<string, any>[];
  resourceTypeOptions: Record<string, any>[];
  selectedSourceType: Record<string, any>;
  selectedResourceType: Record<string, any>;
  selectedAccount: Record<string, any>;
  selectedRegion: Record<string, any>;
  labelOptions: Record<string, any>[];
  cloudOptions: Record<string, any>[];
  selectedCloud: Record<string, any>;
  selectedLabel: Record<string, any>;
  selectedSensitivity: Record<string, any>;
  selectedDataType: Record<string, any>;
  sensitivityOptions: Record<string, any>[];
  dataTypeOptions: Record<string, any>[];
}

export interface DataDashboardContextProps {
  time: Record<string, any>;
  regionOptions: Record<string, any>[];
  accountOptions: Record<string, any>[];
  sourceTypeOptions: Record<string, any>[];
  resourceTypeOptions: Record<string, any>[];
  selectedSourceType: Record<string, any>;
  selectedResourceType: Record<string, any>;
  selectedAccount: Record<string, any>;
  selectedRegion: Record<string, any>;
  labelOptions: Record<string, any>[];
  cloudOptions: Record<string, any>[];
  selectedCloud: Record<string, any>;
  selectedLabel: Record<string, any>;
  selectedSensitivity: Record<string, any>;
  selectedDataType: Record<string, any>;
  sensitivityOptions: Record<string, any>[];
  dataTypeOptions: Record<string, any>[];
  drawerFilters: DataDashboardFilterState;
  updateValue(field, value);
  updateDrawerValue(field, value);
  getDataFootprint();
  getTableData();
  getDataTypeSources(dataType, useDrawerState?: boolean);
}

export const DataDashboardContext = createContext<DataDashboardContextProps>({
  time: {},
  regionOptions: [],
  accountOptions: [],
  sourceTypeOptions: [],
  resourceTypeOptions: [],
  selectedSourceType: {},
  selectedResourceType: {},
  selectedAccount: {},
  selectedRegion: {},
  labelOptions: [],
  cloudOptions: [],
  selectedCloud: {},
  selectedLabel: {},
  selectedSensitivity: {},
  selectedDataType: {},
  sensitivityOptions: [],
  dataTypeOptions: [],
  drawerFilters: {
    time: {},
    regionOptions: [],
    accountOptions: [],
    sourceTypeOptions: [],
    resourceTypeOptions: [],
    selectedSourceType: {},
    selectedResourceType: {},
    selectedAccount: {},
    selectedRegion: {},
    labelOptions: [],
    cloudOptions: [],
    selectedCloud: {},
    selectedLabel: {},
    selectedSensitivity: {},
    selectedDataType: {},
    sensitivityOptions: [],
    dataTypeOptions: [],
  },
  updateValue: () => {},
  updateDrawerValue: () => {},
  getDataFootprint: () => {},
  getTableData: () => {},
  getDataTypeSources: () => {},
});

export const DataDashboardContextProvider = DataDashboardContext.Provider;

export const useDataDashboardContext = () => useContext(DataDashboardContext);
